import React from "react";
import Newsletter_42 from "../component/Newsletter_42";

function Newsletter_42_Container() {
  return <Newsletter_42 />;
}

export default Newsletter_42_Container;
